import { notify } from '@billy/design-system'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { useRemoveAttachmentOwnerReference } from '@features/attachments/hooks/useRemoveAttachmentOwnerReference'
import { useInvalidateTransactions } from '@features/transactions/hooks/useInvalidateTransactions'
import { useUserOrganization } from '@modules-deprecated/app/organization'

import { useInvalidateDaybookTransaction } from './useInvalidateDaybookTransaction'

export const useDeleteDaybookTransactionAttachment = (daybookTransactionId: string) => {
  const { t } = useTranslation()
  const { organization } = useUserOrganization()
  const { invalidateDaybookTransaction } = useInvalidateDaybookTransaction()
  const { invalidateTransactions } = useInvalidateTransactions()
  const { remove } = useRemoveAttachmentOwnerReference()

  const deleteAttachment = useCallback(
    (attachmentId: string) => {
      remove(
        { attachmentId, organizationId: organization?.id as string },
        {
          onSuccess: () => {
            invalidateDaybookTransaction(daybookTransactionId)
            invalidateTransactions()
            notify({
              id: 'daybook-transaction-attachment-remove',
              message: t('journal.notification.attachment_delete_success'),
              variant: 'success',
            })
          },
          onError: () => {
            notify({
              id: 'daybook-transaction-attachment-remove',
              message: t('journal.notification.attachments_update_error'),
              variant: 'error',
            })
          },
        },
      )
    },
    [remove, organization?.id, daybookTransactionId, invalidateDaybookTransaction, invalidateTransactions, t],
  )

  return { deleteAttachment }
}
